const Loudspeaker = () => (
  <svg
    aria-hidden="true"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.625 18.75V20.25L20.625 18.75V16.875"
      stroke="#1890FF"
      strokeWidth="1.33"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M3.75 10.875H0.75"
      stroke="#1890FF"
      strokeWidth="1.33"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M4.875 7.125L2.25 5.625"
      stroke="#1890FF"
      strokeWidth="1.33"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M4.875 14.625L2.25 16.125"
      stroke="#1890FF"
      strokeWidth="1.33"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
    <path
      d="M7.5 18.75L21.8903 14.6385C22.282 14.5265 22.6267 14.29 22.872 13.9647C23.1173 13.6393 23.25 13.243 23.25 12.8355V8.9145C23.25 8.50704 23.1173 8.11065 22.872 7.78533C22.6267 7.46001 22.282 7.22347 21.8903 7.1115L7.5 3V18.75Z"
      stroke="#1890FF"
      strokeWidth="1.33"
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
  </svg>
)

export default Loudspeaker
